import { Injectable } from '@angular/core';
import { Commands } from '@local/client-contracts';
import { isNativeWindow } from '@local/common-web';
import { ResultContextMenuItem } from '../../models/results-types';
import { ResultCommandBuilder } from '../../services/result-command-builder.service';
import { StaticResultsCommandBuilderParams } from './static-results-context-menu-helper';

export type StaticResultContextMenuType = 'collection-url' | 'collection-file' | 'collection-header';

@Injectable({
  providedIn: 'root',
})
export class StaticResultsCommandBuilder extends ResultCommandBuilder {
  isNative = isNativeWindow();
  private readonly buildDefaultCommands: { [key in StaticResultContextMenuType]: boolean } = {
    'collection-file': true,
    'collection-header': false,
    'collection-url': true,
  };

  async build(params: StaticResultsCommandBuilderParams): Promise<ResultContextMenuItem[]> {
    let items: ResultContextMenuItem[] = [];
    if (this.buildDefaultCommands[params.model.type]) {
      items = await super.build({
        resourceId: params.resourceId,
        open: params.open,
        isFavorite: params.isFavorite,
        copy: params?.copy,
        download: params.download,
        preview: params.preview,
        removeCommands: params.removeCommands,
      });
    }
    if (params?.dynamicCommands && !params.removeCommands?.dynamicCommands) {
      params.dynamicCommands.forEach((command) => {
        switch (command) {
          case 'remove':
            items.push({
              id: 'remove',
              text: 'Remove',
              command: { type: 'dynamicCommands', value: 'remove' } as Commands.DynamicCommand,
              icon: { type: 'font-icon', value: 'icon-delete' },
            });
            break;
          case 'rename':
            items.push({
              id: 'rename',
              text: 'Rename',
              command: { type: 'dynamicCommands', value: 'rename' } as Commands.DynamicCommand,
              icon: { type: 'font-icon', value: 'icon-edit-frame' },
            });
            break;
          case 'copy':
            items.push({
              id: 'copy',
              text: 'Make a copy',
              command: { type: 'dynamicCommands', value: 'copy' } as Commands.DynamicCommand,
              icon: { type: 'font-icon', value: 'icon-copy-3' },
            });
            break;
          case 'add-to-collection':
            items.push({
              id: 'add_to_collection',
              text: 'Add to Collection',
              command: { type: 'add-to-collection' },
              icon: { type: 'font-icon', value: 'icon-collection' },
            });
            break;
          default:
            break;
        }
      });
    }
    return items;
  }
}
